export default __webpack_public_path__ + "static/media/GoodMannerWithYourParents_11.ada28492.png";